// extracted by mini-css-extract-plugin
module.exports = {"header":"FooterHeader_header__Gu4Ji","faqItemTitle":"FooterHeader_faqItemTitle__ttX2k","accordionButton":"FooterHeader_accordionButton__Wl5bX"};